import { signal } from '@preact/signals-react';
import { EditorDeclarativeBlock } from '@/webapi/use-experience-api';
import { PageRedirectOptions } from '@/webapi/use-widget-catalog-api';

export const pageRedirectProps = signal<PageRedirectOptions>(null);
export const pageRedirectNewChange = signal<EditorDeclarativeBlock>(null);
export const isSourceModalVisible = signal(false);

export function initializeState(originalChange: EditorDeclarativeBlock) {
  pageRedirectNewChange.value = originalChange;
  pageRedirectProps.value =
    originalChange?.pageRedirectOpts ||
    ({
      stickinessMode: `none`,
      retainQueryParams: true,
    } as PageRedirectOptions);
}
